import React from 'react';
import classNames from 'classnames';
import $ from 'jquery';
import { TimelineMax } from 'gsap';

const Answer = ({ answer, leadText, incScratcherPos, selectChoice, d, y,
  scratcherPosition, numberOfQuestions, userId, sessionId, questionId }) =>  {

  const personality = `${leadText} <strong>${answer.text}</strong>`;

  const handleAnswer = (e, answer, personality, selection) => {
      e.preventDefault();
      if (!window.mobile) {

        //   vars
        let bulbs = $('.wreath--questions .js-bulb');

        //   move card
          let card = $('.wreath__card');
          let questions = $('.wreath__card-questions');
          //
          let choice = new window.TimelineMax();


        choice
        .add(function() {
          selectChoice(
            answer,
            personality,
            scratcherPosition,
            numberOfQuestions,
            selection,
            userId,
            sessionId,
            questionId);
        })
        .to(card, 0.1, {y:5}, 'cardOut')
        .to(questions, 0.1, {autoAlpha: 0,y:5}, 'cardOut')

        .to(card, 0.5, {y:0}, 'cardIn')
        .to(questions, 0.5, {autoAlpha: 1,y:0}, 'cardIn')

      } else {
          selectChoice(
            answer,
            personality,
            scratcherPosition,
            numberOfQuestions,
            selection,
            userId,
            sessionId,
            questionId);
      }

  }

  return (
    <a
      className="wreath__button"
      id={`question${scratcherPosition}`}
      href={`question${scratcherPosition}`}
      data-question={scratcherPosition}
      onClick={e => handleAnswer(e, answer.scratcher, personality, answer.text)}
    >
      <path className="wreath__button-rect" stroke="#00B6FA" strokeMiterlimit="10" d={d}/>
      <text className="wreath__button-text" textAnchor="middle" x="412.85" y={y}>{answer.text}</text>
    </a>
  );
}

export default Answer;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Questions/Answer.js
 **/